import React, { useState, useEffect } from 'react'
import axios from '../../../../Axios'
import { Urls } from '../../../../Urls'
import { Container, Row, Column } from "../../../Shared/FlexDiv/FlexDiv";
// import { Container, Row, Column, TwoColumnLayout } from "../../../Shared/FlexDiv/FlexDiv";
import Loader from '../../../Loader';
import classes from './Credit.module.css'
import { Constants } from '../../../../Constants';
import { toast } from 'react-toastify';
import mixpanel from 'mixpanel-browser'

const Credits = ({ referralCredits, closeModal }) => {
    const [availableReferences, setAvailableReferences] = useState([])
    const [emailInput, setEmailInput] = useState('')
    const [allowedReferrals, setAllowedReferrals] = useState(0)
    const [show, setShow] = useState(false)
    useEffect(() => {
        setShow(true)
        axios.get(Urls.MyAccount.Get.ReferalsAndVAS)
            .then(res => {
                if (res.data && res.data.referrals)
                    setAvailableReferences(res.data.referrals.map(item => item.email.toUpperCase()))
                setShow(false)
            })
            .catch(err => setShow(false))
            mixpanel.track(`User has clicked on get more credit button`, {
                ApplicationName: `${Urls.mixpanelappname}`,
                ScreenName: 'LoRRI-Locationdashboard',   
                ModuleName: 'landing_page',     
                ActivityLog: 'userClickedGetMoreButton',     
                Data: `None`,     
                Definition: `User has clicked on get more credit button`,     
                ActivityType: 'page_view',
                UserName: `${localStorage.getItem("userdetails")}`,
                UserEmail: `${localStorage.getItem("useremail")}`,
                CompanyName: `${localStorage.getItem("companyname")}`
            });
    }, [])
    useEffect(() => {
        // console.log(referralCredits)
        if (referralCredits) {
            setAllowedReferrals(6 - (referralCredits.referrals_credits * 2 + referralCredits.pending_referrals_count))
        }
    }, [referralCredits])
    const AddReference = () => {
        if (!new RegExp(Constants.Email.regex).test(emailInput)) {
            toast.error('Please enter valid email id');
            return;
        }
        else if (availableReferences.includes(emailInput.trim().toUpperCase())) {
            toast.error('You Have Already Referred This User');
            return;
        }
        else {
            setShow(true)
            axios.post(Urls.References.Save,
                {
                    referrals: [
                        {
                            email: emailInput
                        }
                    ]
                }
            )
                .then(res => {
                    toast.success("Reference Added Successfully")
                    setAllowedReferrals(allowedReferrals - 1)
                    setAvailableReferences([...availableReferences, emailInput.toUpperCase()])
                    setEmailInput('')
                    setShow(false)
                })
                .catch(err => {
                    toast.error("Failed to add")
                    setShow(false)
                })
        }
    }
    const openWhatsapp = (e) => {
        window.open(`https://api.whatsapp.com/send?phone=919833973964`, '_blank');
        e.preventDefault();
    }
    return (
        <Container className={classes['Container']}>
            <Loader show={show} />
            {
                allowedReferrals > 0 ?
                    <Column>
                        <div className=" text-center mt-2">
                            <span className={classes['Title']}>
                                Refer your Colleagues or Logistics Managers from other companies now and get upto 3 additional Location Credits !
                            </span>
                            <h4 className={classes['SubTitle']} >(Only corporate E-Mail ids are allowed)</h4>
                            <h4 className={classes['SubTitle']}>2 valid References = 1 Location Credit | Maximum Location credits Allowed = 3</h4>
                        </div>
                        <Row className={classes['margin-left-right']}>
                            <Column className={`${classes['margin-left-right']} ${classes['width-100per']}`}>
                                <input type="text" value={emailInput} style={{ marginBottom: '0px', width: '100%' }} onChange={e => setEmailInput(e.target.value)} placeholder="Enter Reference Email" />
                            </Column>
                            <Column className={classes['margin-left-right']}>
                                <button className="btn btn-primary" onClick={e => AddReference()}>Add</button>
                            </Column>
                        </Row>
                    </Column>
                    :
                    <div className={`row ${classes['justify-content-center']}`}>
                        <span className={classes['Title']}>
                            Location Credits you can get through providing references has been exhausted
                         <br />
                        For any Query :Call us on 9999534677 | Drop a message on Whatsapp
                        <i className={`fa fa-whatsapp ${classes['whatsapp-contact']}`} onClick={e => openWhatsapp(e)} />
                        </span>
                    </div>
            }
            <h4 className={classes['Title']} style={{ color: '#393185' }}>People Whom You have Already Referred</h4>
            <Column className={classes['Referred_list']}>
                {
                    availableReferences.map((item, index) => <Row key={index} className={classes['styled-Row']}>{item ? item.toLowerCase() : item}</Row>)
                }
            </Column>
            <Row className={`${classes['justify-content-center']} ${classes['Title']}`}>
                For any query:
                Call us on  +91 9653620207 or +91 9867773508.
            </Row>
            <Row className={classes['justify-content-center']}>
                <button className="btn btn-primary" onClick={e => closeModal()}>Submit</button>
            </Row>
        </Container>
    )
}
export default Credits
